module.exports = __webpack_public_path__ + "static/img/Contact-blue.dc2b6f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Contact-blue.png
// module id = wzty
// module chunks = 0